import {
  Button,
  CircularProgress,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { AppContext } from "../../../scripts/context/App";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 450,
  minHeight: "fit-content",
  bgcolor: "#fff",
  borderRadius: "4px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

const ADD_FILE_MODAL_CONTENT_STYLE = {
  p: 3,
  gap: 1,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  maxHeight: "60vh",
};

export default function AddFileModal({
  isOpen,
  setISOpen,
}: {
  isOpen: boolean;
  setISOpen: (isOpen: boolean) => void;
}) {
  const { user } = useContext(AppContext);
  const { currentPath, project, setState }: any = useOutletContext();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const handleClose = () => setISOpen(false);

  const submitModal = async () => {
    if (!user.permissions.includes("create_folder"))
      return toast.error("You don't have permission to create folders");
    if (!name.trim()) return setError("Please enter a name");

    try {
      setError("");
      setIsCreating(true);
      await axios.post("/deploy/create-folder", {
        project_uuid: project.id,
        folder_name: name,
        path: currentPath,
      });

      setState({
        project: {
          ...project,
          files_data: [{ text: name, droppable: true }, ...project.files_data],
        },
      });

      setName("");
      handleClose();
    } catch (error: any) {
      console.log({ error });

      if (error.response?.data.errors) {
        toast.error(
          error.responce.data.errors.folder_name[0] || "Something went wrong"
        );
      } else {
        toast.error(
          error.response?.data?.message ||
          "Something went wrong. Please try again later."
        );
      }
      setIsCreating(false);
    }

    setIsCreating(false);
  };

  return (
    <Modal
      keepMounted
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="Preview-User-Modal"
    >
      <Box sx={style}>
        <Box sx={{ p: 3, borderBottom: "1px solid #d3d3d3" }}>
          <Typography
            variant="h6"
            component="h2"
            sx={{ wordBreak: "break-all" }}
          >
            Add New Folder
          </Typography>
        </Box>

        <Box sx={ADD_FILE_MODAL_CONTENT_STYLE}>
          <TextField
            id="filename-input"
            name="filename"
            value={name}
            label={"File Name"}
            variant="standard"
            onChange={(e) => setName(e.target.value)}
            error={error !== ""}
            helperText={error}
            inputProps={{ maxLength: 100 }}
          />
        </Box>

        <Box
          sx={{
            gap: 1,
            p: 3,
            borderTop: "1px solid #d3d3d3",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (!user.permissions.includes("create_folder"))
                return toast.error(
                  "You don't have permission to create folders"
                );

              submitModal();
            }}
            disabled={isCreating}
            endIcon={isCreating && <CircularProgress size={20} />}
          >
            Create
          </Button>
          <Button
            variant="outlined"
            color="error"
            disabled={isCreating}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
